import { Component } from '@angular/core'


@Component({
  selector: 'se-po-setup-bar-docs',
  templateUrl: './setup-bar-docs.component.html',
  styleUrls: ['./setup-bar-docs.component.scss'],
  standalone: false,
})
export class SetupBarDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public setupBarComponent: any = [
    {
      Property: '@Input() percentage',
      Type: 'number',
      Description: 'Percentage of setup complete',
    },
    {
      Property: '@Input() seFeDataTitle',
      Type: 'string',
      Description: 'Title of setup bar',
    }
  ]
}
